<template>
  <button
    type="button"
    class="aha-tag"
    @click="$emit('click', $event)"
    :class="[
      `aha-tag-${size}`,
      `aha-tag-${variant}`,
      {'active': isActive}
    ]"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'base',
    },
    size: {
      type: String,
      default: 'md',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-tag {
  @apply min-w-10;
  @apply border whitespace-nowrap;
  @apply transform transition-all duration-100;
  @apply inline-flex items-center justify-center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.aha-tag-base {
  @apply border-secondary-20 text-secondary-100;
  @apply hover:border-primary-90 hover:text-primary-90;
  background: #FAFAFA;
  &:active:not(:disabled), &.active {
    @apply border-primary-100 text-primary-100;
    @apply hover:border-primary-110 hover:text-primary-110;
  }
  &:focus:not(:disabled) {
    outline: 1px solid #89BEFA;
  }
}

.aha-tag-primary {
  &:active:not(:disabled), &.active {
    @apply bg-primary-100;
  }
  @apply bg-primary-90;
}

.aha-tag-xs {
  @apply px-0.5 py-0.5 text-1.5xs space-x-0.5;
}

.aha-tag-sm {
  @apply text-xs px-2 py-1;
}

.aha-tag-md {
  @apply px-3 py-1.5 text-sm space-x-2;
  @apply min-w-16;
}

/* Design: 40px, below: 40px */
.aha-tag-lg {
  @apply px-3 py-2 text-sm space-x-2;
}

/* Design: 44px, below: */
.aha-tag-xl {
  @apply px-4 py-2.5 text-sm h-10 space-x-2;
}
</style>
